import { PropsWithChildren, useEffect, useState } from "react";
import useLawTerms from "@/hooks/useLawTerms";
import {
  LawTermsContext,
  LawTermsContextType,
} from "./LawTermsContext";

const LawTermsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { useQueryAllLawTerms } = useLawTerms();
  const fetchedAllLawTerms = useQueryAllLawTerms();
  const [allLawTerms, setAllLawTerms] =
    useState<LawTermsContextType["allLawTerms"]>(null);

  useEffect(() => {
    if (fetchedAllLawTerms.isSuccess && fetchedAllLawTerms.data) {
      setAllLawTerms(fetchedAllLawTerms.data);
    }
  }, [fetchedAllLawTerms.data, fetchedAllLawTerms.isSuccess]);

  const contextValue: LawTermsContextType = {
    allLawTerms,
    isLoading: fetchedAllLawTerms.isPending,
    isError: fetchedAllLawTerms.isError ?? false,
  };

  return (
    <LawTermsContext.Provider value={contextValue}>
      {children}
    </LawTermsContext.Provider>
  );
};

export default LawTermsProvider;
